import React from "react";

const formatarDinheiro = (valor, mostrar_zero) => {
    if (!valor && !mostrar_zero)
        return <span className={"text-center"}>—</span>;
    return Intl.NumberFormat('pt', {style: 'currency', currency: 'EUR'}).format(valor || 0).replace("€ ", "") + " €";
};

export default formatarDinheiro;